import React, { useState, FunctionComponent, useEffect, useCallback } from 'react';
import { Presentation } from './presentation';
import { fetchPersonHistories } from '../../../services/personProfiles';
import { Favorite, Entry, Scout, PersonShowModalScoutListStateProps } from '../../../types/personShow';

type Props = {
  personId: number;
  title: string;
  target: string;
  favoritesCounts: number;
  entriesCounts: number;
  scoutsCounts: number;
  type: string;
};

export const Component: FunctionComponent<Props> = ({
  personId,
  title,
  target,
  favoritesCounts,
  entriesCounts,
  scoutsCounts,
  type,
}) => {
  const [state, setState] = useState<PersonShowModalScoutListStateProps>({
    favorites: [] as Favorite[],
    entries: [] as Entry[],
    scouts: [] as Scout[],
    list: type || 'favorites' as 'favorites' | 'entries' | 'scouts',
    isSmallModal: false,
    scoutCreatedAt: '',
    scoutTitle: '',
    scoutMessage: '',
  });

  useEffect(() => {
    const request = async () => {
      try {
        const response = await fetchPersonHistories(personId);
        setState(prev => ({
          ...prev,
          favorites: response.favorites,
          entries: response.entries,
          scouts: response.scouts,
        }));
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, [personId]);

  useEffect(() => {
    setState(prev => ({ ...prev, list: type }));
  }, [type]);

  const handleClick = useCallback((target: 'favorites' | 'entries' | 'scouts') => {
    setState(prev => ({ ...prev, list: target }));
  }, []);

  const handleSmallModalOpen = useCallback(() => {
    setState(prev => ({ ...prev, isSmallModal: !prev.isSmallModal }));
  }, []);

  const handleSetScout = (event: React.MouseEvent<HTMLAnchorElement>, item: Scout | Favorite | Entry) => {
    if (state.list === 'scouts') {
      const scoutItem = item as Scout;
      event.preventDefault();
      handleSmallModalOpen();
      setState(prev => ({
        ...prev,
        scoutCreatedAt: scoutItem.createdAt,
        scoutTitle: scoutItem.title,
        scoutMessage: scoutItem.message,
      }));
    }
  };

  return (
    <Presentation
      state={state}
      handleClick={handleClick}
      handleSetScout={handleSetScout}
      handleSmallModalOpen={handleSmallModalOpen}
    />
  );
};
